import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import type { BudgetClassificationCodeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-classification-code/budget-classification-code-find.dto';

import * as yup from 'yup';

/** Budget revenue admin response body - DTO signature */
export interface BudgetRevenueAdminFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: string;

  // Tech columns
  /** Budget revenue admin creation date and type */
  created: Date;
  /** Budget revenue admin last update date and type */
  updated: Date;
  /** Budget revenue admin soft deletion date and type */
  deleted?: Date;

  // Data columns
  /** Budget revenue admin unique code (three digits) */
  code: string;
  /** Budget revenue admin display name */
  name: string;
  /** Budget classification codes belong to this budget revenue admin */
  budgetClassificationCodes?: BudgetClassificationCodeFindInterface[];
}

/** Budget revenue admin response body - DTO schema */
export const BudgetRevenueAdminFindDto = SerdeDtoClass.create<BudgetRevenueAdminFindInterface>(CatalogDtosKeysEnum.BUDGET_REVENUE_ADMIN_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.string(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  code: {
    sortable: true,
    label: 'Код',
    serializer: yup.string(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  budgetClassificationCodes: {
    optional: true,
    label: 'КБК',
    nested: CatalogDtosKeysEnum.BUDGET_CLASSIFICATION_CODE_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
